export const websocketPort = process.env.REACT_APP_WEBSOCKETPORT;
//DEV: 'http://localhost:3002' or PROD: "https://unified.cascais.dev-dttsynergy.com:443";